import React, {Component} from 'react';
import {
  withRouter
} from 'react-router-dom'
import './detailBtn.scss'
import Swipes from "../Swipes";

@withRouter

export default class DetailBtn extends Component {
  constructor(props) {
    super(props);
    this.state = {}
    this.swipes = {
      distance: 690, //每次移动的距离，卡片的真实宽度
      currentPoint: 1, //初始位置，默认从第一个开始
      autoPlay: false, //是否开启自动播放
    }
  }

  componentDidMount() {

  }

  render() {
    const {
      normal_item,
      style = {}
    } = this.props;
    // 参数说明：
    // show_type 1：小图，2：大图 3：无图 4：三图
    // type 1:图文 2：视频 3：专题 4：图说 6：直播 20：视频组 50：外链 20: 音频
    return (
      <div className="detailBtn"
           style={{...style}}
      >
        {normal_item.show_type / 1 === 1 && normal_item.type / 1 !== 3 && normal_item.type / 1 !== 20 ? //小图
          <div>
            <div className="smallCover">
              <img src={normal_item.type / 1 === 50 ? normal_item.row.cover_list[0].url : normal_item.row.cover}
                   alt="封面图"/>
              {normal_item.type / 1 === 2 ?
                <div className="manuTimeBox">
                  <span className="play-icon"></span>
                  <span>{this.props.changeTime(normal_item.row.ext_data.duration)}</span>
                </div> :
               normal_item.type / 1 === 21 ? //如果是音频稿件--音频图标
                  <div className='audio_icon'></div> :
               normal_item.type / 1 === 50 ?
                  <span className="advSmallICon">推广</span> : ''
              }
            </div>
            <div className="smallCoverTitle">
              <div className="right_title line_2">{normal_item.row.title}</div>
              {normal_item.type / 1 !== 50 && normal_item.type / 1 !== 6 ?
                <span className="right_tag">{normal_item.row.column_info&&normal_item.row.column_info[0]&&normal_item.row.column_info[0].column_name}</span> : ''
              }
              <span
                className="right_time">{this.props.changeBeforeTime(normal_item.row.publish_timestamp, normal_item.row.publish_time)}</span>
            </div>
          </div> :
          normal_item.show_type / 1 === 2 ? //大图
            <div>
              {normal_item.type / 1 === 50 ?
                <div className="advBigCover">
                  <img src={normal_item.row.cover_list[0].url} alt="外链大图"/>
                  <span className="advICon">推广</span>
                </div> :
                normal_item.type / 1 === 20 ?
                  <Swipes group={normal_item.group}
                          goDetail={this.props.goDetail}
                          changeTime={this.props.changeTime}
                  />
                  :
                  <div>
                    <div className="bigCover">
                      {/* 2023年3月23日原big_cover更改为cover_list[0].url */}
                      <img src={normal_item.row.cover_list[0].url} alt="封面大图"/>
                      {normal_item.type / 1 === 3 ?
                        <span className="specialIcon"></span> 
                        : normal_item.type / 1 === 2 ? //视频稿件
                          <div className="videoTimeBox">
                            <span className="play-icon"></span>
                            <span>{this.props.changeTime(normal_item.row.ext_data.duration)}</span>
                          </div>
                        : normal_item.type / 1 === 21 ? //音频稿件
                        <div class="audio_icon_big"></div>
                      : ''
                      }
                    </div>
                    <div className="bigCoverTitle line_2">{normal_item.row.title}</div>
                  </div>
              }
            </div> :
            normal_item.show_type / 1 === 3 && normal_item.type / 1 !== 3 && normal_item.type / 1 !== 20 ? //无图
              <div>
                <div className="noCoverTitle line_2">{normal_item.row.title}</div>
                <div className="noCoverBottom">
                  {normal_item.row.column_info.length > 0 ?
                    <div className="bottomTag">{normal_item.row.column_info[0].column_name}</div> : ''
                  }
                  <div
                    className="bottomTime">{this.props.changeBeforeTime(normal_item.row.publish_timestamp, normal_item.row.publish_time)}</div>
                </div>
              </div> :
              normal_item.show_type / 1 === 4 && normal_item.type / 1 !== 3 && normal_item.type / 1 !== 20 ? //三图
                <div>
                  <div className="threeCoverTitle line_2">{normal_item.row.title}</div>
                  <ul className="threeCoverBox">
                    {normal_item.row.cover_list.map((item, index) => {
                      return <li className="threeCover" key={index}>
                        <img src={item.url} alt="封面图"/>
                        {index === 0 && normal_item.type / 1 === 50 ?
                          <span className="threeAdvIcon">推广</span> :
                          index === 0 && normal_item.type / 1 === 2 ?
                            <div className="videoTimeBox">
                              <span className="play-icon"></span>
                              <span>{this.props.changeTime(normal_item.row.ext_data.duration)}</span>
                            </div> : ''
                        }
                      </li>
                    })}
                  </ul>
                </div> : ''
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/DetailBtn/detailBtn.js